<template>
    <section class="themes xl:py-spc5 md:py-spc17">
        <div class="container">
            <SectionHeadings
                    title="Jekyll documentation themes"
                    titlelink="#"
                    titleclass="xl:text-size4 text-size4 md:text-3xl"
                    desc="Need to document your app or product, or create a support website?
Here are the best Jekyll themes for your new documentation project."
                    descclass="xl:text-size5 text-size5 md:text-size8 mt-spc6" />
        </div>

        <div class="container p-0">
            <div class="themes-wrap flex flex-wrap">

                <div class="item xl:w-2/6 md:w-1/2 xl:px-spc7 px-spc7 md:px-5 xl:mt-spc5 mt-spc5 md:mt-10" v-for="docstheme in docsthemes" :key="docstheme.id">
                    <div class="theme">
                        <router-link :to="docstheme.cardLink" class="theme-img block overflow-hidden">
                            <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                            </div>
                            <div class="theme-screenshot">
                                <img :src="docstheme.img" alt="Theme">
                            </div>
                        </router-link>
                        <div class="theme-content mt-5">
                            <h1 class="flex items-center text-size6 font-bold relative pr-spc5">
                                <router-link :to="docstheme.cardLink" class="text-secondary hover:text-primary">
                                    {{docstheme.title}}
                                </router-link>
                                <span v-if="docstheme.marker" class="theme-marker text-size7 bg-primary text-white uppercase tracking-spc2 leading-spc5 inline-block pt-1 pb-spc9 px-2 ml-spc10">
                                    {{docstheme.marker}}
                                </span>
                                <span class="right absolute right-0 text-size5 font-light text-whitelight tracking-spc1">
                                    {{docstheme.price}}
                                </span>
                            </h1>
                            <p class="xl:text-base text-base text-paragraph leading-spc3 font-medium md:text-size13">
                                {{docstheme.subtitle}}
                            </p>
                        </div>
                    </div>
                </div>

            </div>

            <SectionsButton title="All Documentation Themes" url="#" />
        </div>

    </section>
</template>

<script>
    import SectionHeadings from "../common/SectionHeadings";
    import SectionsButton from "../common/SectionsButton";
    export default {
        name: "DocumentationThemes",
        components: {
            SectionsButton,
            SectionHeadings
        },
        computed: {
            docsthemes() {
                return this.$store.state.documentationThemes;
            }
        }
    }
</script>

<style scoped>

</style>